import styled from "styled-components/macro";
import { IncomingSampleTasksTable } from "../Tables/Tasks/IncomingSampleTasksTable";

const Layout = styled.div`
  padding: 56px 0;
`;

export function TaskTableScreen(): JSX.Element {
  return (
    <Layout>
      <IncomingSampleTasksTable />
    </Layout>
  );
}
